const capitalizeWords = (str) => {
    if (!str) return '';
  
    // Eccezioni specifiche (case insensitive)
    const exceptions = {
      'motogp': 'MotoGP',
      'endurancegt': 'Endurance&GT',
      'imsa': 'IMSA',
      'wec': 'WEC',
      'wrc': 'WRC',
      'sbk': 'SBK',
      'civ': 'CIV',
      'gt': 'GT',
      'motoe': 'MotoE',
      'formula-1': 'Formula 1',
      'formula-2': 'Formula 2',
      'formula-3': 'Formula 3',
      'formula-e': 'Formula E',
      'trofeo-motoestate': 'Trofeo Motoestate',
      'gt-world-challenge-europe': 'GT World Challenge Europe',
      'gt-italiano': 'GT Italiano',
      'risultati-gare-cigt-wec': 'Risultati gare CIGT WEC',
      'risultati-gare-f1': 'Risultati gare F1',
      'risultati-gare-moto': 'Risultati gare Moto',
      'risultati-gare-formula-e': 'Risultati gare Formula E',
      'approfondimenti-f1': 'Approfondimenti F1',
      'approfondimenti-endurancegt': 'Approfondimenti Endurance&GT',
      'approfondimenti-moto': 'Approfondimenti Moto',
      'approfondimenti-formula-e': 'Approfondimenti Formula E',
      'news-endurancegt': 'News',
      'news-moto': 'News',
      'news-formula-e': 'News',
    };
  
    return str
      .split(' ')
      .map((word) => {
        const lowerCaseWord = word.toLowerCase();
  
        // Applica eccezioni se esistono
        if (exceptions[lowerCaseWord]) {
          return exceptions[lowerCaseWord];
        }
  
        // Capitalizzazione standard
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(' ');
  };
  
  export default capitalizeWords;
  